import React from 'react';
import Surveys from '@components/KeyInformation/Surveys';
import PageLayout from '@features/shared/components/PageLayout';
import { usePageInitialization } from '@features/shared/hooks/usePageInitialization';

/**
 * Survey Page - Displays available surveys
 */
const SurveyPage = () => {
  usePageInitialization();

  return (
    <PageLayout title="Survey" backPath="/">
      <Surveys />
    </PageLayout>
  );
};

export { SurveyPage };
export default SurveyPage;
